<template>
    <card class="spaced typo" v-show="loaded">

        <div class="pt-2" v-if="ctrl.rows.length || search">

            <h2 class="text-white mb-4">{{ $t('common.stores') }}</h2>

            <table-control :paging="ctrl.paging" :search="true" v-model="search"></table-control>

            <base-table :data="ctrl.rows" :columns="columns" thead-classes="d-none">

                <template slot-scope="{row}">
                    <td>
                        {{row.name}}
                    </td>
                    <td class="td-actions text-right">

                        <base-button icon link size="md" type="info" @click="selectOwner(row)">
                            <i class="tim-icons icon-move-right"></i>
                        </base-button>

                        <base-button icon link size="md" type="warning" @click="ctrl.update(row.id)" v-if="editAllowed">
                            <i class="tim-icons icon-pencil"></i>
                        </base-button>

                        <base-button icon link size="md" type="danger" @click="remove(row.id)" v-if="editAllowed">
                            <i class="tim-icons icon-simple-remove"></i>
                        </base-button>

                    </td>
                </template>

            </base-table>

            <table-pagination :paging="ctrl.paging"></table-pagination>
        </div>

        <p class="text-center py-3" v-else>{{ $t('stores.no-store') }}</p>
                
        <div class="text-center">

            <base-button type="primary" @click="ctrl.create()" v-if="!deleting">
                {{ $t('stores.new') }}
            </base-button>

            <base-button type="default" :disabled="true" :loading="true" v-if="deleting">
                {{ $t('stores.deleting') }}
            </base-button>

        </div>

        <portal to="modals">

            <modal class="no-footer" :title="$t('common.store')" v-model="ctrl.modals.edit" :loading="ctrl.form.loading">
                <owner-form v-model="ctrl.form.data" :errors="ctrl.form.errors"></owner-form>
            </modal>

            <modal-confirm v-model="ctrl.modals.confirmDelete">
                <p>{{ $t('stores.delete-confirm') }}</p>
            </modal-confirm>

        </portal>

    </card>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'
    import OwnerForm from './OwnerForm'

    export default {

        components: {
            OwnerForm
        },

        data() {
            return {
                loaded: false,
                deleting: false,
                ctrl: new CrudController({
                    endpoint: '/trax/api/front/owners',
                    mapData: this.mapData,
                    unmapData: this.unmapData,
                    paging: {
                        perPage: 10,
                        perPageOptions: [5, 10, 25, 50],
                        total: 0
                    },
                    query: {
                        sort: ['name']
                    },
                    callbacks: {
                        deleteConfirmed: this.deleteConfirmed,
                        deleted: this.deleted
                    }
                }),
                search: '',
                columns: ['name']
            }
        },

        computed: {
            editAllowed() {
                return this.$auth.hasPermission('owner.manage')
            }
        },
        
        created() {
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
            })
        },

        watch: {
            search(val) {
                this.ctrl.filter({name: {$text: val}})
            }
        },

        methods: {
            
            selectOwner(owner) {
                this.$auth.owner = owner
                this.$auth.saveOwner()
                this.$router.push({name: 'home'})
            },

            mapData(owner) {
                return {
                    id: owner ? owner.id : null,
                    name: owner ? owner.name : null,
                }
            },

            unmapData(data) {
                return data
            },

            remove(id) {
                this.ctrl.modals.open('confirmDelete').then(resp => {
                    if (resp.confirmed) {
                        axios.delete(
                            '/trax/api/front/xapi/ext/stores/' + id,
                        )
                        .then(response => {
                            this.ctrl.list()
                        })
                        .catch(error => {
                            if (err.response.status == 423) {
                                this.$notify({type: 'danger', message: this.$t('errors.423-delete') })
                            } else if (err.response.status == 403) {
                                this.$notify({type: 'danger', message: this.$t('errors.403-delete') })
                            } else {
                                this.$auth.handleErrorVm(error, this)
                            }
                        });
                    }
                })
            },

            deleteConfirmed() {
                this.deleting = true
            },

            deleted(resp) {
                this.deleting = false
            }
        }
    }
</script>
